import _cloneDeep from 'lodash/cloneDeep';

export default {
  remittanceAdvices: (state) => _cloneDeep(state.remittanceAdvices),
};
